import styled from "styled-components";

export const StyledExternalRewardWrapper = styled.div`
  > div:first-child {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    gap: 4px;

    > div {
      width: min-content;
      min-width: 116px;
    }
  }
`;

export const StyledRewardsWrapper = styled.div`
  > div {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    gap: 4px;

    > div {
      width: min-content;
      min-width: 64px;
    }
  }
`;
